import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const CreatingRolePhase = memo(function CreatingRolePhase({
  disabled,
  progressIcon,
  successIcon,
  errorIcon,
}: CreatingRolePhaseProps): JSX.Element {
  return (
    <ServiceConnectionStep disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {progressIcon ? <CircularProgress size="24px" sx={{ mr: 1 }} /> : null}
        {successIcon ? (
          <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
        ) : null}
        {errorIcon ? (
          <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
        ) : null}
        <Typography variant="body1">Creating Read-only Role...</Typography>
      </Box>
      <Stack sx={{ mt: 2 }} spacing={1} direction="column">
        <Typography variant="body1">
          We create and use a separate, read-only IAM role called
          `ThreatKeyAudit` to periodically scan the account and/or dig into
          potential security issues.
        </Typography>

        <Typography variant="body1">
          Unless you enable fixes on the next page, this is the{" "}
          <strong>only</strong> IAM role that you&apos;ll see us use.
        </Typography>
      </Stack>
    </ServiceConnectionStep>
  );
});

export default CreatingRolePhase;

// -----------------------------------------------------------------------------

interface CreatingRolePhaseProps {
  disabled: boolean;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
